import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Pagination, EffectFade, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { Link } from "react-router-dom";

function BannerOne() {
  const swiperRef = useRef(null);

  useEffect(() => {
    const animationProperties = () => {
      document.querySelectorAll("[data-ani]").forEach((element) => {
        const animationName = element.getAttribute("data-ani");
        element.classList.add(animationName);
      });

      document.querySelectorAll("[data-ani-delay]").forEach((element) => {
        const delayTime = element.getAttribute("data-ani-delay");
        element.style.animationDelay = delayTime;
      });
    };

    animationProperties();
  }, []);

  const handleSliderNavigation = (direction) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const swiper = swiperRef.current.swiper;
      direction === "prev" ? swiper.slidePrev() : swiper.slideNext();
    }
  };

  return (
    <div className="th-hero-wrapper hero-1" id="hero">
      <Swiper
        modules={[Navigation, Pagination, EffectFade]}
        effect="fade"
        loop={true}
        speed={1000}
        pagination={{ el: ".swiper-pagination", clickable: true }}
        navigation={{ nextEl: ".slider-next", prevEl: ".slider-prev" }}
        className="th-slider hero-slider-1"
        id="heroSlide1"
      >
        {/* ---------- SLIDE 1: OFFICE PRINTERS ---------- */}
        <SwiperSlide>
          <div className="hero-inner">
            <div
              className="th-hero-bg hero-overlay"
              style={{
                backgroundImage: "url(/assets/img/bg/banner1.jpg)",
              }}
            ></div>
            <div className="container">
              <div className="hero-style1">
                <span
                  className="sub-title sharp"
                  data-ani="fadein"
                  data-ani-delay="0.2s"
                >
                  Productivity. Reliability. Precision.
                </span>
                <h1
                  className="hero-title sharp"
                  data-ani="slideinup"
                  data-ani-delay="0.4s"
                >
                  Office Printers Engineered for Business Growth
                </h1>
                <p
                  data-ani="fadein"
                  data-ani-delay="0.6s"
                  className="hero-desc"
                >
                  Power your workplace with fast, secure, and high-volume
                  printers designed to keep teams moving. Experience seamless
                  wireless printing, low-cost output, and exceptional clarity.
                </p>

                <div
                  className="btn-group"
                  data-ani="fadein"
                  data-ani-delay="0.8s"
                >
                  <Link to="/shop" className="sharp-btn primary-btn">
                    Explore Printers
                  </Link>
                  <Link to="/contact" className="sharp-btn outline-btn">
                    Get a Quote
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>

        {/* ---------- SLIDE 2: HOME PRINTERS ---------- */}
        <SwiperSlide>
          <div className="hero-inner">
            <div
              className="th-hero-bg hero-overlay"
              style={{
                backgroundImage: "url(/assets/img/bg/banner2.jpg)",
              }}
            ></div>
            <div className="container">
              <div className="hero-style1">
                <span
                  className="sub-title sharp"
                  data-ani="fadein"
                  data-ani-delay="0.2s"
                >
                  Smart. Compact. Affordable.
                </span>
                <h1
                  className="hero-title sharp"
                  data-ani="slideinup"
                  data-ani-delay="0.4s"
                >
                  Home Printers Designed for Everyday Convenience
                </h1>
                <p
                  data-ani="fadein"
                  data-ani-delay="0.6s"
                  className="hero-desc"
                >
                  Print homework, documents, and photos effortlessly. Our home
                  printing solutions deliver quiet operation, easy setup, and
                  budget-friendly ink options for your daily needs.
                </p>

                <div
                  className="btn-group"
                  data-ani="fadein"
                  data-ani-delay="0.8s"
                >
                  <Link to="/shop" className="sharp-btn primary-btn">
                    Browse Models
                  </Link>
                  <Link to="/contact" className="sharp-btn outline-btn">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>

        {/* ---------- SLIDE 3: LASER PRINTERS ---------- */}
        <SwiperSlide>
          <div className="hero-inner">
            <div
              className="th-hero-bg hero-overlay"
              style={{
                backgroundImage: "url(/assets/img/bg/banner3.jpg)",
              }}
            ></div>
            <div className="container">
              <div className="hero-style1">
                <span
                  className="sub-title sharp"
                  data-ani="fadein"
                  data-ani-delay="0.2s"
                >
                  Speed Meets Perfection
                </span>
                <h1
                  className="hero-title sharp"
                  data-ani="slideinup"
                  data-ani-delay="0.4s"
                >
                  Laser Printers for Ultra-Sharp Professional Output
                </h1>
                <p
                  data-ani="fadein"
                  data-ani-delay="0.6s"
                  className="hero-desc"
                >
                  Achieve unmatched clarity with long-lasting toner efficiency.
                  Ideal for high-volume environments that demand crisp text,
                  fast output, and dependable performance.
                </p>

                <div
                  className="btn-group"
                  data-ani="fadein"
                  data-ani-delay="0.8s"
                >
                  <Link to="/shop" className="sharp-btn primary-btn">
                    View Laser Series
                  </Link>
                  <Link to="/contact" className="sharp-btn outline-btn">
                    Talk to an Expert
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <div className="th-swiper-custom">
          <button
            className="slider-arrow slider-prev"
            onClick={() => handleSliderNavigation("prev")}
          >
            <img src="/assets/img/icon/right-arrow.svg" alt="Prev" />
          </button>

          <div className="swiper-pagination" />

          <button
            className="slider-arrow slider-next"
            onClick={() => handleSliderNavigation("next")}
          >
            <img src="/assets/img/icon/left-arrow.svg" alt="Next" />
          </button>
        </div>
      </Swiper>

      {/* ---------- STYLES ---------- */}
      <style>{`
        .hero-overlay {
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          position: relative;
        }
        .th-hero-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  z-index: 1;
}

.hero-overlay::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 2;
}

       .hero-inner {
  position: relative;
  height: 80vh;
  display: flex;
  align-items: center;
  z-index: 3;
}


        .hero-style1 {
          position: relative;
          z-index: 5;
          max-width: 650px;
          color: #fff;
        }

        .sub-title.sharp {
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .hero-title.sharp {
          font-size: 48px;
          font-weight: 800;
          line-height: 1.2;
          margin: 15px 0;
        }

        .hero-desc {
          color: #e5e5e5;
          font-size: 18px;
          margin-bottom: 25px;
        }

        /* BUTTONS — sharp edges, NO rounded corners */
        .sharp-btn {
          padding: 14px 32px;
          font-size: 16px;
          font-weight: 600;
          border: none;
          cursor: pointer;
          text-transform: uppercase;
          text-decoration: none;
          display: inline-block;
        }

        .primary-btn {
          background: #4C8BF5;
          color: white;
        }

        .primary-btn:hover {
          background: #2364d8;
        }

        .outline-btn {
          background: transparent;
          border: 2px solid #fff;
          color: white;
          margin-left: 12px;
        }

        .outline-btn:hover {
          background: #fff;
          color: #000;
        }

        .btn-group {
          display: flex;
          align-items: center;
        }
      `}</style>
    </div>
  );
}

export default BannerOne;
